import React from 'react';
import LocationTemplate from './LocationTemplate';

const RaleighPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Raleigh"
      stateName="North Carolina"
      countyName="Wake"
      zipCodes={["27601", "27602", "27603", "27604", "27605", "27606", "27607", "27608", "27609", "27610", "27611", "27612", "27613", "27614", "27615", "27616", "27617", "27695"]}
      latitude={35.7796}
      longitude={-78.6382}
      population={474069}
      historicalFact="Founded in 1792 as North Carolina's capital city, named after Sir Walter Raleigh."
      nearbyTowns={[
        "Durham, NC",
        "Cary, NC",
        "Wake Forest, NC",
        "Garner, NC",
        "Apex, NC",
        "Knightdale, NC",
        "Clayton, NC",
        "Chapel Hill, NC"
      ]}
    />
  );
};

export default RaleighPage;